import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Centralised <head> manager for each page.
 * - title: short title; final tag = "{title} — ALOFI SA"
 * - description: meta description
 */
export default function PageHead({ title, description }) {
  const fullTitle = title ? `${title} — ALOFI SA` : 'ALOFI SA — Votre Partenaire en Approvisionnement';
  const desc = description || 'Grossiste & Détaillant B2B en France. Qualité et prix garantis. Demandez votre devis personnalisé.';
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
    </Helmet>
  );
}
